import { useDialogContext } from '../../../contexts/DialogContext';
import { window } from '../../../globals';
import { getAuthorizeServiceURL } from '../../../helpers/services';
import { post } from '../../../redux/api';
import { BUTTON_TYPE, NavigationButton } from '../../generic';
import Button from '../../generic/Button';
import Icon, { icons } from '../../generic/Icon';
import Header from '../../shared/settings/SettingsPageHeader';
import Section from '../../shared/settings/SettingsPageSection';

const GitlabSettings = () => {
  const { onConfirm } = useDialogContext();

  return (
    <>
      <Header heading="GitLab Login" />
      <Section>
        <Section.Left heading="GitLab Login">
          <Section.Paragraph>
            FOSSA allows users to link a GitLab login to their FOSSA login.
          </Section.Paragraph>
        </Section.Left>
        <Section.Right>
          {!window.user?.gitlab ? (
            <>
              <h4>You are not connected to GitLab</h4>
              <div className="margin-top-lg">
                <NavigationButton
                  to={getAuthorizeServiceURL({
                    vcsHost: 'gitlab',
                    location: window.location.href,
                    serviceConnect: true,
                  })}
                  type={BUTTON_TYPE.SECONDARY}
                  openInNewTab
                >
                  <Icon icon={icons.gitlab} /> Connect to GitLab
                </NavigationButton>
              </div>
            </>
          ) : (
            <>
              <h4>
                You are currently connected{' '}
                {window.user?.gitlab?.name ? (
                  <span>
                    as <b>{window.user?.gitlab?.name}</b>
                  </span>
                ) : (
                  <span>to GitLab</span>
                )}
              </h4>
              <div className="margin-top-lg">
                <Button
                  type={BUTTON_TYPE.SECONDARY}
                  onClick={() => {
                    onConfirm({
                      title: 'Confirm GitLab disconnect',
                      body: (
                        <div>
                          <p>
                            <b>Are you sure you want to disassociate the current user with the registered GitLab account?</b>{' '}
                            (cannot be undone)
                          </p>
                        </div>
                      ),
                      onConfirm: async () => {
                        await post('/api/services/gitlab/disconnectService', null);
                        window.location.reload();
                      },
                    });
                  }}
                >
                  Disconnect
                </Button>
              </div>
            </>
          )}
        </Section.Right>
      </Section>
    </>
  );
};

export default GitlabSettings;
